exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.label-checkbox[data-v-accbc3e2] {\n\tpadding: 2px 0 0 0;\n}\n.a-border-bottom[data-v-accbc3e2] {\n\tborder-bottom: 1px solid rgba(0, 0, 0, 0.1);\n}\n", ""]);

// exports
